mutation ToggleFavoriteVideo (
    $videoId: ID!
) {
    toggleFavoriteVideo (
        video_id: $videoId
    ) {
        status
        message
    }
}
